import { v7 as uuidv7 } from 'uuid';
import { token } from '@/infrastructure/container';

// UUIDv7 is lexicographically time-ordered, so sorting by id is a free creation-order tiebreak.

export interface IIdGen {
  next(): string;
}

export class UuidV7Gen implements IIdGen {
  next(): string {
    return uuidv7();
  }
}

export const TOKEN_IIdGen = token<IIdGen>('IIdGen');
